module.exports = __webpack_public_path__ + "img/google.3d8c1a01.png";